module.exports = __webpack_public_path__ + "static/magazynowanie-1-54f5c208876f160b4fbbd84d71bcf2cd.jpg";